import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { CreateOfferGroupRequest } from '~client/model/admin/create-offer-group-request';
import { OfferGroupResponse } from '~client/model/admin/offer-group-response';

/**
 * Creates a new Offer Group
 * @param request
 */
export const performCreateOfferGroup = (
  request: CreateOfferGroupRequest,
): Observable<OfferGroupResponse> =>
  apiClient.marketplaceAdminController.createOfferGroup$(request);



// WEBPACK FOOTER //
// ./interactor/offer-group/perform-create-offer-group.ts